<template>
<b-row>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateFrom')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateFrom')"
                            v-model.lazy="filters.callDateTimeFrom"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
  <b-col md="3" sm="12">
    <b-form-group>
      <label>{{$t('views.excmrelation.show.dateTo')}}:</label>
      <VueCtkDateTimePicker no-header
                            :label="$t('views.excmrelation.show.dateTo')"
                            v-model.lazy="filters.callDateTimeTo"
                            v-debounce="delay"
                            format="YYYY-MM-DD"
                            :onlyDate="true"
                            :right="true"
                            formatted="ll"
      >
      </VueCtkDateTimePicker>
    </b-form-group>
  </b-col>
</b-row>
</template>

<script>
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import debounce from 'v-debounce'
export default {
  name: 'CallLogStatisticFiltering',
  components: {
    VueCtkDateTimePicker
  },
  directives: {
    debounce
  },
  props: {
    callLogRelatedContractorFilter: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      filtersReference: {},
      delay: 500,
      filters: {
        callDateTimeFrom: this.$moment().subtract(31, 'days').format('YYYY-MM-DD'),
        callDateTimeTo: ''
      }
    }
  },
  created () {
    this.$emit('filter', this.filters)
  },
  watch: {
    filters: {
      deep: true,
      handler () {
        this.$emit('filter', this.filters)
      }
    }
  }
}

</script>

<style scoped>

</style>
